import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "frisbuy-fully-widget-container__close-button-wrapper" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M17.6077 6.29437C17.2138 5.90724 16.5807 5.91272 16.1936 6.3066L11.9878 10.5857L7.70878 6.38003C7.31489 5.9929 6.68175 5.99838 6.29462 6.39227C5.90748 6.78615 5.91296 7.4193 6.30685 7.80643L10.5859 12.0121L6.38006 16.2914C5.99293 16.6852 5.9984 17.3184 6.39229 17.7055C6.78618 18.0926 7.41932 18.0872 7.80645 17.6933L12.0123 13.414L16.2916 17.6199C16.6855 18.0071 17.3186 18.0016 17.7058 17.6077C18.0929 17.2138 18.0874 16.5807 17.6935 16.1935L13.4142 11.9876L17.6199 7.70853C18.0071 7.31465 18.0016 6.6815 17.6077 6.29437Z",
    fill: "#999999"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "frisbuy-fully-widget-container__content-wrapper-inner" }

import {
  onBeforeUnmount,
  onMounted,
  ref,
} from "vue";
import { TSwipe } from "../../globals";


export default /*#__PURE__*/_defineComponent({
  __name: 'FullyWidgetContainer',
  emits: ["close"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

onMounted(() => {
  lockWindowScroll();
});

onBeforeUnmount(() => {
  unlockWindowScroll();
});

function onBlurHandler() {
  emit("blur");
}

function lockWindowScroll() {
  document.documentElement.style.overflow = "hidden";
}

function unlockWindowScroll() {
  document.documentElement.style.overflow = "";
}

function onSwipeHandler(direction: TSwipe) {
  emit("swipe", direction);
}

const contentWrapper = ref<HTMLElement | null>(null);

function scrollHandler(e: Event) {
  const target = e.target as HTMLElement;
  const scrollTop = target.scrollTop;

  // Scroll position event
  const scrollBottom = target.scrollHeight - (target.offsetHeight + scrollTop);
  emit("scroll", {
    top: scrollTop,
    bottom: scrollBottom,
  });
}


return (_ctx: any,_cache: any) => {
  const _directive_touch = _resolveDirective("touch")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "frisbuy-fully-widget-container",
    onClick: _cache[2] || (_cache[2] = _withModifiers(() => onBlurHandler(), ["self"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "closeButton", {}, () => [
        _createElementVNode("button", {
          class: "frisbuy-fully-widget-container__close-button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, _hoisted_3)
      ])
    ]),
    _createElementVNode("div", {
      class: "frisbuy-fully-widget-container__content-wrapper",
      ref_key: "contentWrapper",
      ref: contentWrapper,
      onScroll: _cache[1] || (_cache[1] = (e) => scrollHandler(e))
    }, [
      _createElementVNode("div", _hoisted_4, [
        _renderSlot(_ctx.$slots, "content")
      ])
    ], 544)
  ])), [
    [_directive_touch, (direction) => onSwipeHandler(direction), "swipe"]
  ])
}
}

})